import httpClient from '@api/httpClient'
import type { PaginatedResponse } from '@models/pagination'
import type { SmsEvent, SmsEventsFilters } from '@models/smsEvent'
import { smsEventsUrls } from './constants'

const getSmsEventsAdmin = async (
  filters: SmsEventsFilters,
): Promise<PaginatedResponse<SmsEvent>> => {
  const { data } = await httpClient.get<PaginatedResponse<SmsEvent>>(
    smsEventsUrls.smsEventsAdmin,
    {
      params: filters,
    },
  )
  return data
}

export default { getSmsEventsAdmin }
